<template>
  <div class="mb-6">
    <ul class="text-sm">
      <li v-for="(bulletPoint, index) in product.properties.bulletPoints" :key="`${index}-bulletpoint`" class="mb-2">
        <span class="font-bold">{{ bulletPoint.title }}</span>
        <p v-if="bulletPoint.text" class="text-xs">
          {{ bulletPoint.text }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      required: true,
      type: Object
    }
  }
}
</script>
